<template>
    <div id="productPreviewArea" :class="{'motif-admin' : isMotifAdmin}">
        <div id="productFullPreview" ref="productFullPreview">
            <img ref="productOverlay1"
                 :src="
          this.imagePath +
          '/images/product-overlays/option-' +
          userProduct.optionId +
          '-1.png'
        " />
            <img ref="productOverlay2"
                 :src="
          this.imagePath +
          '/images/product-overlays/option-' +
          userProduct.optionId +
          '-2.png'
        " />
            <div id="productBackgroundArea">
                <a @click="$emit('open-background')"
                   id="linkBackground"
                   title="Change Background"></a>
            </div>
            <!--:force-fallback="true"-->
            <!--:support-pointer="false"-->
            <draggable ref="productPreview"
                       :list="productMotifs"
                       class="product-preview"
                       :data-motif-count="productMotifs.length"
                       :data-size="userProduct.sizeId"
                       :data-color="userProduct.bgFlossId"
                       :force-fallback=this.isSafari
                       :style="{
                       backgroundColor:
                       '#' +
                       this.productInfo.palettecolors.find(
                       (p)=>
                p.flossId == this.userProduct.bgFlossId
                ).flossHtml,
                backgroundImage:
                'url(' +
                (this.productInfo.backgroundimages.find(
                (p)=>
                p.backgroundImageId == this.userProduct.bgImageId
                ) ? this.productInfo.backgroundimages.find(
                (p)=>
                p.backgroundImageId == this.userProduct.bgImageId
                ).backgroundImageUrl : '')


                + ')',
                }"
                group="ProductMotifs"
                @start="onDragStart"
                @end="onDragEnd"
                >
                <transition-group type="transition"
                                  name="flip-list"
                                  tag="div"
                                  class="product-motifs"
                                  ref="productMotifs">
                    <div :class="{ 'product-motif': true, custom: pm.customMotifInputs }"
                         v-for="pm in productMotifs"
                         :key="pm.id" v-on="pm.customMotifInputs ? { dblclick: () => editMotif(pm) } : {}">
                        <div class="remove" v-on:click="removeMotif(pm)"></div>
                        <div class="edit" v-on:click="editMotif(pm)" alt="Edit"></div>
                        <Motif :m="pm.motifData" />
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
    import Motif from "@/components/Motif.vue";
    import MotifData from "@/objects/MotifData.js";
    import Globals from "@/globals.js";
    import draggable from "vuedraggable";
    import { mapState } from "vuex";

    export default {
        name: "ProductPreview",
        data() {
            return {
                sizeId: 0,
                imagePath: '',
                isSafari: navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                    navigator.userAgent &&
                    navigator.userAgent.indexOf('CriOS') == -1 &&
                    navigator.userAgent.indexOf('FxiOS') == -1,
                isMotifAdmin: (Globals.getFinishStep() == 3),

            };
        },
        computed: {
            ...mapState(["productMotifs", "userProduct", "productInfo"]),
        },
        components: {
            Motif,
            draggable,
        },
        methods: {
            removeMotif(pm) {

                this.$store.dispatch("removeMotifFromProduct", pm);
                Globals.checkWidth(this.$store);
            },
            editMotif(pm) {
                let pmMotif = new MotifData(pm.motifData);
                this.$emit("open-custom-motif", pmMotif, pm);
            },
            onDragStart() {
                const html = document.getElementsByTagName("html").item(0);
                html.classList.toggle("dragging", true);
            },
            onDragEnd() {
                const html = document.getElementsByTagName("html").item(0);
                html.classList.toggle("dragging", false);
            },
            updateSize() {
                this.sizeId = this.userProduct.sizeId;
                let productElement = this.$refs.productFullPreview;


                let productSize = this.productInfo.sizes.find(
                    (s) => s.sizeId === this.userProduct.sizeId
                );

                let pWidth = productSize.sizeWidth;
                let pHeight = productSize.sizeHeight;



                //console.log(100/24);
                //console.log("pWidth: " + pWidth);
                //console.log("Globals.stitchesPerInch: " + Globals.stitchesPerInch);
                //console.log("Globals.backgroundStitchHeight: " + Globals.backgroundStitchHeight);

                let bgHeight = ((Globals.backgroundStitchHeight / Globals.stitchesPerInch) * 100) / pHeight;


                document.documentElement.style.setProperty('--p-height', pHeight);

                document.documentElement.style.setProperty('--p-width', pWidth);
                document.documentElement.style.setProperty('--motif-height', 1 / pHeight * 100 + "%");

                document.documentElement.style.setProperty('--background-height', bgHeight + "%");

                if ((Globals.getProductType() == 7) && (this.productMotifs.length < 3)) {
                    document.documentElement.style.setProperty('--motif-area-width', (pWidth - ((Globals.leatherOverhang() + (Globals.safetyMargin() * 0.5))) * 2) / pWidth * 100 + "%");
                } else {
                    document.documentElement.style.setProperty('--motif-area-width', "100%");
                }

                //console.log(pHeight);
                let aspect = pHeight / pWidth;
                let cssHeight = "calc(" + pHeight + " / " + pWidth + " * 100vw)";
                let cssMaxHeight = "calc(" + pHeight + " / " + pWidth + " * " + Globals.maxWidth() + "px)"; //this needs to match the max-width of #productPreviewArea
                productElement.setAttribute(
                    "style",
                    "height:" + cssHeight + "; max-height:" + cssMaxHeight
                );
                //let screenOverhang = 100 - (Globals.leatherOverhang() * 100) / pWidth + "%";
                let screenOverhang = 100 - ((Globals.leatherOverhang() + (Globals.safetyMargin() * 0.5)) * 100) / pWidth + "%"; //set overlay to be the leather overhang value + half of the safety margin
                this.$refs.productOverlay1.setAttribute(
                    "style",
                    "right:" + screenOverhang
                );
                this.$refs.productOverlay2.setAttribute(
                    "style",
                    "left:" + screenOverhang
                );


                let bgOffset = (Globals.backgroundOffset() * 100) / pWidth + "%";

                document.documentElement.style.setProperty('--p-bgOffset', bgOffset);


                //console.log(productSize.sizeWidth);
                let oneStitchWidth = 100 / productSize.sizeWidth / Globals.stitchesPerInch;
                //console.log("oneStitchWidth: " + oneStitchWidth);
                //console.log(Globals.stitchMotifCurrentSpacing);
                //console.log((Globals.stitchMotifCurrentSpacing * oneStitchWidth) / 2);
                //console.log((Globals.stitchMotifCurrentSpacing * 100) / (productSize.sizeWidth) / Globals.stitchesPerInch / 2);
                document.documentElement.style.setProperty('--motif-margin', (Globals.stitchMotifCurrentSpacing * oneStitchWidth) / 2 + "%")
                //document.documentElement.style.setProperty('--motif-margin', (Globals.stitchMotifCurrentSpacing * 100) / productSize.sizeWidth / 2 + "%")
            },
        },

        beforeCreate() {
            if (this.$store.state.userProduct.sizeId == undefined) {
                //console.log("x");
                this.$router.push('/');
            }
        },
        updated: function () {

            this.updateSize();


        },
        mounted: function () {


            document.documentElement.style.setProperty('--pp-max-width', Globals.maxWidth() + "px");

            this.updateSize();
            this.imagePath = Globals.appRoot;

            console.log("product preview mounted");

            Globals.checkWidth(this.$store);

            if (Globals.isModProduct() != 1) {
                // Globals.openFirstCustomMotif();
                let productMotifs = this.$store.state.productMotifs;

                if (productMotifs.length && (productMotifs[0].customMotifInputs) && (productMotifs.length > 0))
                    this.editMotif(productMotifs[0]);
                //this.openPopup();

            }
        },
    };
</script>

<style>
    .flip-list-move-active {
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.5s ease;
    }

    .flip-list-enter-active,
    .flip-listt-leave-active {
    transition: all 0.5s ease;
    }

    .flip-list-enter,
    .flip-list-leave {
    opacity: 0;
    transform: translateY(30px);
    }

    #productPreviewArea {
    height: calc(var(--p-height) / var(--p-width) * 100vw + 3.5em);
    max-height: calc(var(--p-height) / var(--p-width) * var(--pp-max-width) + 3.5em);
    max-width: var(--pp-max-width);
    margin: 0 auto;
    width: 100%;
    min-height: 4.5em;
    }

    #productFullPreview {
    position: relative;
    transform: translateY(calc( -50%));
    top: 50%;
    z-index: 10000;
    }

    #linkBackground:hover {
    background: #ffffff2e;
    cursor: pointer;
    }

    #linkBackground {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    }

    .product-preview {
        --main-bg-color: #3296d4;
        --prod-width: attr(data-width);
        --width-diff: 7;
        width: 100%;
        height: 100%;
        /*background: var(--main-bg-color);*/
        position: absolute;
        flex: 0 1 auto;
        top: 0;
        box-shadow: 0 3px 4px #666, 0 0px 2px #666;
        pointer-events: none;
        background-size: auto var(--background-height);
        background-position: 0% 50%;
        -ms-interpolation-mode: nearest-neighbor;
        image-rendering: -moz-crisp-edges;
        image-rendering: pixelated;
        background-position-x: var(--p-bgOffset);
    }

    .product-preview .product-motifs {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    height: 100%;
    pointer-events: none;
    justify-content: center;
    width: var(--motif-area-width);
    margin: auto;
    }

    .product-preview .product-motifs .product-motif {
    flex-direction: row;
    height: calc(100% + 2.4em);
    position: relative;
    margin: -1.2em var(--motif-margin);
    padding: 1.2em 0;
    cursor: -webkit-grab;
    cursor: grab;
    pointer-events: all;
    /*flex: 1 0 auto;*/
    }

    .key-fob .product-preview[data-motif-count="1"] .product-motifs .product-motif,
    .key-fob .product-preview[data-motif-count="2"] .product-motifs .product-motif {
    width: 50%;
    flex: 0 0 auto;
    margin-left: 0;
    margin-right: 0;
    }
    .key-fob .product-preview[data-motif-count="1"] .product-motifs {
    justify-content:left;
    }

    .product-preview .product-motifs .product-motif .motif {
    height: 100%;
    justify-content: center;
    display: flex;
    min-width: auto;
    max-width: auto;
    }

    .product-preview .product-motifs .product-motif .remove {
    position: absolute;
    display: none;
    cursor: pointer;
    color: #ccc;
    width: 100%;
    height: 1.2em;
    line-height: 1.2em;
    font-weight: bold;
    left: 50%;
    transform: translate(-50%, -1.4em);
    }

    .product-preview .product-motifs .product-motif .remove::before {
    left: calc(50% - 0.6em);
    width: 1.2rem;
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.8em;
    border-radius: 100%;
    content: "\2716";
    display: inline-block;
    }

    .product-preview .product-motifs .product-motif .remove:hover::before {
    background: #ccc;
    color: #fff;
    }

    .product-preview .product-motifs .product-motif .edit {
    position: absolute;
    display: none;
    cursor: pointer;
    color: #ccc;
    width: 100%;
    height: 1.2em;
    line-height: 1.2em;
    left: 50%;
    transform: translate(-50%, 0);
    top: calc(100% - 1em);
    }

    .product-preview .product-motifs .product-motif.custom .edit::before {
    left: calc(50% - 0.6em);
    width: 1.2rem;
    height: 1.2rem;
    line-height: 1.2rem;
    font-size: 0.8em;
    border-radius: 100%;
    content: "\270F";
    transform: rotate(45deg);
    display: inline-block;
    }

    .product-preview .product-motifs .product-motif.custom .edit:hover::before {
    background: #ccc;
    color: #fff;
    }

    .product-preview .product-motifs .product-motif:hover .remove,
    .product-preview .product-motifs .product-motif:hover .edit {
    display: block;
    }

    .product-preview .product-motifs .product-motif .motif img {
    height: var(--motif-height);
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    -ms-interpolation-mode: nearest-neighbor;
    image-rendering: -moz-crisp-edges;
    image-rendering: pixelated;
    image-rendering: crisp-edges;
    flex: 0 0 auto;
    transform-origin: top;
    }

    .product-preview .product-motifs .product-motif:hover .motif img {
    filter: brightness(110%);
    transform: scale(1.04) translateY(-50%);
    }

    #productBackgroundArea:hover ~ .product-preview::before {
    content: "";
    position: absolute;
    background: rgb(255 255 255 / 0.1);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: dotted 2px #43434345;
    }

    .product-preview::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: url(https://www.needlepaint.com/images/stitches.png) repeat-x;
    top: 0;
    left: 0;
    background-size: contain;
    mix-blend-mode: multiply;
    pointer-events: none;
    z-index: 2;
    }

    #productFullPreview > img {
    position: absolute;
    height: 158%;
    z-index: 3;
    top: 50%;
    transform: translateY(-50%);
    }


    #productPreviewArea.motif-admin {
    margin: 1em auto;
    height: unset;
    max-height: unset;
    max-width: unset;
    }


    #productPreviewArea.motif-admin #productFullPreview {
    height: auto !important;
    max-height: unset !important;
    transform: none;
    top: auto;
    }



    #productPreviewArea.motif-admin #productFullPreview > img {
    display: none;
    }

    #productPreviewArea.motif-admin .product-preview {
    position: unset;
    box-shadow: none;
    }

    #productPreviewArea.motif-admin .product-preview .product-motifs {
    position: unset;
    flex-wrap: wrap;
    gap: .75em;
    padding: 1em !important;
    }

    #productPreviewArea.motif-admin .product-preview .product-motifs .product-motif {
    height: 5em;
    }

    #productPreviewArea.motif-admin .product-preview::after {
    background-size: auto 3em;
    background-repeat: repeat;
    }
</style>
